module.exports = "/_next/static/images/3d4ea87a4897be3612ef8abdc4da0dd8-xpeer-lg.jpg.webp";